import { differenceInMinutes } from 'date-fns';
import { padNumberToLength } from '../utils/pad-number-to-length';
const getFormattedOffset = (params, delimiter = '') => {
    const offset = differenceInMinutes(params.date, params.offsetUtcDate);
    const sign = offset > 0 ? '-' : '+';
    const absOffset = Math.abs(offset);
    const hours = Math.floor(absOffset / 60);
    const minutes = absOffset % 60;
    return sign + padNumberToLength(hours, 2) + delimiter + padNumberToLength(minutes, 2);
};
/**
 * Returns a string representation of the time zone offset: -01:00, +00:00, ... +12:00
 * @hidden
 */
export const getOffset = (params) => {
    return getFormattedOffset(params, ':');
};
/**
 * Returns a string representation of the time zone offset, without the separator: -0100, +0000, ... +1200
 * @hidden
 */
export const getOffsetWithoutSeparator = (params) => {
    return getFormattedOffset(params);
};
//# sourceMappingURL=offset.js.map